import { connect } from 'react-redux';
import React from 'react';
import Pictogram from '../pictogram';
import useWizard from '../wizard/useWizard';
import TranslatedCopy from '../../../intl/translated-copy';

const ModalCancelRefund = () => {
  const { setCancelRefundModal } = useWizard();

  const cancelRefund = () => {
    window.location.replace('/');
  };

  return (
    <div className='ModalCancelRefund'>
      <div className='ModalCancelRefund-details'>
        <div className='ModalCancelRefund-details-modalHandle' />
        <Pictogram className='ModalCancelRefund-details--alertIcon' id='RefundCancelAlert' />
        <div className='ModalCancelRefund-details-warning'>
          <TranslatedCopy
            className='ModalCancelRefund-details-warning--warningMsg'
            copyID='BOARDING_PASS_WARNING_TITLE'
            tagName='p' />
          <TranslatedCopy
            className='ModalCancelRefund-details-warning--confirmationAlertText'
            copyID='MYB_EXIT_THE_PROCESS'
            tagName='p' />
          <TranslatedCopy
            className='ModalCancelRefund-details-warning--confirmationAlertDesc'
            copyID='MYB_IF_YOU_CANCEL'
            tagName='p' />
        </div>
        <TranslatedCopy
          className='ModalCancelRefund-details--continueText'
          copyID='MYB_CONTINUE_WITH_REFUND'
          onClick={ () => setCancelRefundModal(false) }
          tagName='p'
        />
        <TranslatedCopy
          className='ModalCancelRefund-details--confirmBtn'
          copyID='MYB_CONFIRM_EXIT_THE_PROCESS'
          onClick={ () => cancelRefund() }
          tagName='p'
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  pnrInfo: state.Manage.pnrInfo,
});

export default connect(mapStateToProps)(ModalCancelRefund);